var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C9.86377 2 10.7956 2 11.5307 2.30448C12.5108 2.71046 13.2895 3.48915 13.6955 4.46927C14 5.20435 14 6.13623 14 8V8C14 9.86377 14 10.7957 13.6955 11.5307C13.2895 12.5108 12.5108 13.2895 11.5307 13.6955C10.7956 14 9.86377 14 8 14V14C6.13623 14 5.20435 14 4.46927 13.6955C3.48915 13.2895 2.71046 12.5108 2.30448 11.5307C2 10.7956 2 9.86377 2 8V8C2 6.13623 2 5.20435 2.30448 4.46927C2.71046 3.48915 3.48915 2.71046 4.46927 2.30448C5.20435 2 6.13623 2 8 2V2Z",
    stroke: "#171D40",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 8,
    height: 8,
    rx: 2.66667,
    fill: "#171D40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxIcon);
export default __webpack_public_path__ + "static/media/checkBoxIcon.f29f9a748835fcedafaac92b50fc2f90.svg";
export { ForwardRef as ReactComponent };